import { authenticatedFetch } from "@/api/session";
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ??
  "http://localhost:8000";

function getAuthHeaders() {
  const token = localStorage.getItem("access_token");

  return {
    Authorization: `Bearer ${token}`,
  };
}

export type GlobalSearchResult = {
  id: string;
  entity_type:
    | "MEMBER"
    | "HOUSEHOLD"
    | "VISITOR"
    | "SERVICE"
    | "CARE_ITEM";
  title: string;
  subtitle?: string | null;
  path: string;
};

export type GlobalSearchResponse = {
  query: string;
  total: number;
  groups: {
    members: GlobalSearchResult[];
    households: GlobalSearchResult[];
    visitors: GlobalSearchResult[];
    services: GlobalSearchResult[];
    care_items: GlobalSearchResult[];
  };
};

async function parseResponse<T>(
  response: Response,
  errorMessage: string
): Promise<T> {
  if (!response.ok) {
    const body = await response.json().catch(() => null);

    throw new Error(
      body && typeof body.detail === "string"
        ? body.detail
        : errorMessage
    );
  }

  return response.json() as Promise<T>;
}

export async function globalSearch(
  churchId: string,
  query: string
): Promise<GlobalSearchResponse> {
  const params = new URLSearchParams({
    q: query,
  });

  const response = await authenticatedFetch(
    `${API_BASE_URL}/api/churches/${churchId}/search?${params.toString()}`,
    {
      headers: getAuthHeaders(),
    }
  );

  return parseResponse(
    response,
    "Failed to search MinistryIQ"
  );
}